export default "__VITE_ASSET__DLJp0VAD__"